import { httpRequest } from "../../http";

export class CommandGetDefinition {
  async run(definitionId: number) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/`;
    const response = await httpRequest<any>(url, { method: "GET" });
    return response;
  }
}
